import React from 'react';
import Button from '@mui/material/Button';
import ColumnBox from 'components/ColumnBox';
import AddCircle from '@mui/icons-material/AddCircle';
import Restore from '@mui/icons-material/Restore';
import Person from '@mui/icons-material/Person';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CategoryIcon from '@mui/icons-material/Category';

import { useNavigate } from 'react-router-dom';

import BigHeading from 'components/BigHeading';

export default function Form(props) {
    const navigate = useNavigate();

    const goToStoreLedgerReport = function() {
        navigate({ "pathname": "store_ledger_report" })
    }
    const goToStoreBalanceReport = function() {
        navigate({ "pathname": "store_balance_report" })
    }
    const goToDailyCostAnalysis = function() {
        navigate({ "pathname": "daily_cost_analysis" })
    }

    return (
        <ColumnBox sx={{ alignItems: 'center' }}>
            <BigHeading>{props.warehouse} Reports</BigHeading>
            <Button sx={{ marginTop: '15px' }} variant="outlined" size="small"
                onClick={() => { goToStoreLedgerReport() }} startIcon={<CategoryIcon />}>
                Store Ledger Report
            </Button>
            <Button sx={{ marginTop: '15px' }} variant="outlined" size="small"
                onClick={() => { goToStoreBalanceReport() }} startIcon={<AssessmentIcon />}>
                Store Balance Report
            </Button>
            <Button sx={{ marginTop: '15px' }} variant="outlined" size="small"
                onClick={() => { goToDailyCostAnalysis() }} startIcon={<AssessmentIcon />}>
                Daily Cost Analysis
            </Button>
        </ColumnBox>
    );
}
